import React, {PropTypes} from 'react';
import DisplayIf from 'shared/DisplayIf.jsx';

const AccountDetail = ({
  id,
  isActive,
  name,
  loginUrl,
  owner,
  tournamentCount,
  onDeactivateClick,
  onEditAccountNameClick
}) => (  
  <div>    
    <div className="list-group-item-labeled">
      <a className="list-group-item-labeled-child has-link"
        style={{width: 250}}
        href={`${loginUrl}`}>
        <span>{'Account Name'}</span>
        <span>{name}</span>
      </a>
      <div className="list-group-item-labeled-child"
        style={{width: 150}}>
        <span>{'Account Owner'}</span>
        <span>{owner}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 100}}>
        <span className="text-center">{'Tournaments'}</span>
        <span className="text-center">
          {tournamentCount}
        </span>
      </div>
      <div className="list-group-item-labeled-child has-link"
        style={{width: 120}}>
          <DisplayIf condition={isActive} 
               className="animated fadeIn">
            <button
              type="button"
              className="btn btn-link"
              disabled={tournamentCount > 0}
              onClick={() => onDeactivateClick(id)}>
              <i className="fa fa-window-close"/> {'Deactivate'}
            </button>        
          </DisplayIf>
          <DisplayIf condition={!isActive} 
               className="animated fadeIn">
            Deactivated
          </DisplayIf>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 50}}>
        <span>
          <button className="btn btn-link pull-right"
            onClick={() =>onEditAccountNameClick(id)}>
            <i className="fa fa-pencil"/> {'Edit'}
          </button>        
        </span>
      </div> 
    </div>
  </div>
);

AccountDetail.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
  name: PropTypes.string,
  loginUrl: PropTypes.string,
  owner: PropTypes.string,
  tournamentCount: PropTypes.number,
  onDeactivateClick: PropTypes.func,
  onEditAccountNameClick: PropTypes.func
};

AccountDetail.defaultProps = {
  isActive: false
};

export default AccountDetail;



// WEBPACK FOOTER //
// ./src/features/finance/accounts/AccountDetail.jsx